import { render, staticRenderFns } from "./LetterSideBar.vue?vue&type=template&id=7ed537a8&"
import script from "./LetterSideBar.vue?vue&type=script&lang=js&"
export * from "./LetterSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports